import { useEffect } from "react";
import { getDataLayer } from "utils/analytics";
import { gql, useQuery } from "utils/urql";
import ArticleRelatedContentList from "./ArticleRelatedContentList";
import {
  RecommendedRelatedContentQuery,
  RecommendedRelatedContentQueryVariables,
  RecircServiceName,
} from "types/api";

const RECOMMENDED_QUERY = gql`
  ${ArticleRelatedContentList.fragment}

  query RecommendedRelatedContentQuery(
    $id: ID!
    $service: RecircServiceName!
    $algorithm: String
  ) {
    recircRecommendation(id: $id, service: $service, algorithm: $algorithm) {
      displayName
      serviceUsed
      river(first: 3) {
        ...relatedContentRiver
      }
    }
  }
`;

const ArticleRelatedContentRecommended = ({
  id,
  service,
  algorithm,
  count,
}: {
  id: string;
  service: RecircServiceName;
  algorithm?: string | null;
  count: number;
}) => {
  const [{ data }] = useQuery<
    RecommendedRelatedContentQuery,
    RecommendedRelatedContentQueryVariables
  >({
    query: RECOMMENDED_QUERY,
    variables: {
      id,
      service,
      algorithm,
    },
  });
  const content = data?.recircRecommendation;

  useEffect(() => {
    if (content?.serviceUsed) {
      getDataLayer().push({
        event: "Recirc Load",
        recircServiceUsed: `${content.serviceUsed}`,
      });
    }
  }, [content?.serviceUsed]);

  if (!content?.river?.edges.length) return null;

  return (
    <ArticleRelatedContentList
      displayName={content.displayName}
      articles={content.river}
      count={count}
    />
  );
};

export default ArticleRelatedContentRecommended;
